export default __webpack_public_path__ + "static/offcentre-9339c28b123ca6f0a129dbf3a7c22003.png";